import type { InjectionKey } from 'vue'
import type { AdvancedTextImportRow, BasicTextImportRow } from '@/features/text-import/textImportLogic'

export const TEXT_IMPORT_ROW_MENU_CLASS = 'text-import-row-context-menu'

export type TextImportRowContextAction = 'copy' | 'paste' | 'delete'

export type TextImportRowContextApi = {
  runRowAction: (
    variant: 'basic' | 'advanced',
    row: BasicTextImportRow | AdvancedTextImportRow,
    action: TextImportRowContextAction,
  ) => void
}

export const textImportRowContextKey: InjectionKey<TextImportRowContextApi> = Symbol('textImportRowContext')

let menuDismissHandler: ((event: Event) => void) | null = null

function isTextImportRowMenuTarget(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest(`.${TEXT_IMPORT_ROW_MENU_CLASS}`))
}

/** 绑定结果表行菜单的外部点击关闭（捕获阶段，避免行内 stopPropagation 拦截）。 */
export function bindTextImportRowMenuDismiss(onDismiss: () => void): void {
  unbindTextImportRowMenuDismiss()
  menuDismissHandler = (event: Event) => {
    if (isTextImportRowMenuTarget(event.target)) return
    onDismiss()
  }
  window.setTimeout(() => {
    if (!menuDismissHandler) return
    document.addEventListener('pointerdown', menuDismissHandler, true)
    document.addEventListener('contextmenu', menuDismissHandler, true)
    window.addEventListener('scroll', menuDismissHandler, true)
  }, 0)
}

/** 解除结果表行菜单的外部点击关闭。 */
export function unbindTextImportRowMenuDismiss(): void {
  if (!menuDismissHandler) return
  document.removeEventListener('pointerdown', menuDismissHandler, true)
  document.removeEventListener('contextmenu', menuDismissHandler, true)
  window.removeEventListener('scroll', menuDismissHandler, true)
  menuDismissHandler = null
}
